import { takeLatest, all } from 'redux-saga/effects';
import api from 'services/api';

/**
 * On app rehydrate, restore token in Axios
 */
export function setUserToken({ payload }) {
  if (!payload) return;
  const { token } = payload.auth;
  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }
}

/**
 * On sign out, redirect to login
 */
export function signOut() {
  // history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setUserToken),
  takeLatest('@auth/SIGN_OUT', signOut),
  takeLatest('@auth/SIGN_FAILURE', signOut),
]);
